module.exports = __webpack_public_path__ + "images/stickers/taco-reading@2x.0c3110a4622a680fd4a9.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/taco-reading@2x.png
// module id = KWs3
// module chunks = 12